import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { TOKEN_PATH } from './data-access/auth.api';
import { SessionToken } from './session-token';

/** Requests that must stay anonymous: the token endpoint and static i18n files. */
const ANONYMOUS_PATHS = [TOKEN_PATH, '/i18n/'];

export const authHeaderInterceptor: HttpInterceptorFn = (request, next) => {
  const token = inject(SessionToken).value();

  if (token === null || ANONYMOUS_PATHS.some((path) => request.url.includes(path))) {
    return next(request);
  }

  return next(request.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
